// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3rpFt","col":"styles_col__RuOvN","fulfillmentStatus":"styles_fulfillmentStatus__1luj_","emailCol":"styles_emailCol__2kwN1"};